/**
 * Renders article description - supports both sectioned JSON and legacy HTML.
 * Sectioned format: [{"title":"...","content":"<p>...</p>"},...]
 */
export function renderDescriptionHtml(description, fileUrlReplacement) {
  if (!description || typeof description !== 'string') return '';
  const trimmed = description.trim();
  const replaceUrls = (html) =>
    fileUrlReplacement
      ? html.replace(new RegExp('/sites/default/files', 'g'), fileUrlReplacement)
      : html;

  if (trimmed.startsWith('[')) {
    try {
      const sections = JSON.parse(trimmed);
      if (Array.isArray(sections) && sections.length > 0) {
        let stepNum = 0;
        return sections
          .map((s) => {
            if (s.type === 'stepGroupStart') {
              stepNum = 0;
              return '<hr class="doc-step-group-divider" />';
            }
            const isStep = s.type !== 'paragraph';
            if (isStep) stepNum += 1;
            if (isStep) {
              return (
                `<section class="doc-article-section doc-article-step">` +
                `<div class="doc-article-step-header">` +
                `<span class="doc-article-step-number">Step ${stepNum}</span>` +
                (s.title ? `<span class="doc-article-step-title">${escapeHtml(s.title)}</span>` : '') +
                `</div>` +
                `<div class="doc-article-section-content">${replaceUrls(s.content || '')}</div>` +
                `</section>`
              );
            }
            return (
              `<section class="doc-article-section doc-article-paragraph">` +
              `<div class="doc-article-section-content">${replaceUrls(s.content || '')}</div>` +
              `</section>`
            );
          })
          .join('');
      }
    } catch {
      /* fall through to legacy */
    }
  }
  return replaceUrls(trimmed);
}

function escapeHtml(text) {
  if (!text) return '';
  return String(text)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}
